import { ESaleType } from '../../../../../packages/api-models/common/json_query';

export const FLAT_NEW_LIST = [
  { label: 'Неважно', value: null },
  { label: '214-Ф3', value: ESaleType.F3 },
  { label: 'Договор ЖСК', value: ESaleType.GSKContract },
  { label: 'Переуступка', value: ESaleType.Reassignment },
  { label: 'Предварительный договор', value: ESaleType.PreliminaryContract },
  { label: 'Договор инвестирования', value: ESaleType.InvestmentContract },
];

export const OTHERS_LIST = [
  { label: 'Неважно', value: null },
  { label: 'Свободная', value: ESaleType.Free },
  { label: 'Альтернативная', value: ESaleType.Alternative },
];
